module.exports = __webpack_public_path__ + "static/media/loan_amortization.bd287f65.jpg";